/**
 * Shorten a full name to first + last, dropping any middle names.
 *   "Yago Rafael Pessoa" → "Yago Pessoa"
 *   "Maria Silva"        → "Maria Silva"
 *   "Yago"               → "Yago"
 */
export function shortName(full: string | null | undefined): string {
  if (!full) return '';
  const parts = full.trim().split(/\s+/).filter(Boolean);
  if (parts.length <= 1) return parts[0] ?? '';
  return `${parts[0]} ${parts[parts.length - 1]}`;
}

/**
 * First name + last-name initial, for tighter contexts (group standings tables).
 *   "Yago Rafael Pessoa" → "Yago P."
 *   "Maria Silva"        → "Maria S."
 *   "Yago"               → "Yago"
 */
export function compactName(full: string | null | undefined): string {
  if (!full) return '';
  const parts = full.trim().split(/\s+/).filter(Boolean);
  if (parts.length <= 1) return parts[0] ?? '';
  const last = parts[parts.length - 1];
  return `${parts[0]} ${last[0].toUpperCase()}.`;
}
